/*
 * Public API Surface of ngx-clipboard
 */

export * from './lib/ngx-clipboard.service';
export * from './lib/ngx-clipboard.directive';
export * from './lib/ngx-clipboard.module';
export * from './lib/ngx-clipboard-if-supported.directive';
export * from './lib/interface';
